import Table from 'components/Table'
import React from 'react'
import { PRINTCOLUMNS } from './PrintConsultantColumns'
import "./PrintConsultantDirectory.scss"

function PrintConsultantDirectory({ printRef, invoice, value }: any) {
  return (
    <div className='print-consultant-wrapper' ref={printRef}>
      <div className="consultant-directory-heading">Consultant Directory - {`${value === 0 ? "In House" : "Referral Doctors"}`}</div>
      <Table
        data={invoice}
        columns={PRINTCOLUMNS}
        globalFilterRequired={false}
      // onRowClick={(id: any) => redirectTo(id)}
      />
    </div >
  )
}

export default PrintConsultantDirectory